/**
 * Client-side password validation utility
 * Note: This is for UX only. Server-side validation is authoritative.
 */

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

/**
 * Validate password meets minimum requirements
 * - Minimum 8 characters
 * - Maximum 128 characters
 * Note: Common password check is only done server-side
 */
export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = [];

  if (!password || password.length < 8) {
    errors.push("Password must be at least 8 characters long");
  }

  if (password && password.length > 128) {
    errors.push("Password must not exceed 128 characters");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

/**
 * Extract password validation error from API response
 */
export function extractPasswordError(error: any): string {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.password?.[0] ||
    error?.response?.data?.new_password?.[0] ||
    error?.response?.data?.password_data?.new_password?.[0] ||
    "Something went wrong, please try again."
  );
}
